(() => {
  const initFaq = (root = document) => {
    const sections = root.matches?.('[data-snapshop-faq]')
      ? [root]
      : root.querySelectorAll?.('[data-snapshop-faq]') || [];

    sections.forEach((section) => {
      if (section.dataset.faqInitialized === 'true') return;
      section.dataset.faqInitialized = 'true';

      const singleOpen = section.dataset.singleOpen === 'true';
      if (!singleOpen) return;

      section.addEventListener('toggle', (event) => {
        const openedItem = event.target;
        if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.matches('[data-faq-item]') || !openedItem.open) return;

        section.querySelectorAll('[data-faq-item][open]').forEach((item) => {
          if (item !== openedItem) item.removeAttribute('open');
        });
      }, true);
    });
  };

  const onReady = () => initFaq(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaq(event.target);
  });
})();
